export default {
    organList:'/organList', // 机构列表
    brandList:'/brandList', // 终端类型列表
    merchantList:'/merchantList', // 终端&商户
    stockList:'/stockList', // 库存列表
    queryList:'/queryList', // 出入库查询列表
    transferList:'/transferList', // 划拨列表
    rateTable:'/rateTable', // 终端费率表格
}